import { createFileRoute, Outlet, redirect } from "@tanstack/react-router";

import { AppSidebar } from "@/components/layout/app-sidebar";
import { Topbar } from "@/components/layout/topbar";
import { SidebarInset, SidebarProvider } from "@/components/ui/sidebar";
import { TooltipProvider } from "@/components/ui/tooltip";
import { authClient } from "@/lib/auth-client";

// ===========================================================================
// El layout de la aplicación, con el mismo montaje que el ERP.
//
// El guard va en `beforeLoad` y no en un efecto dentro de la página. Es la
// forma canónica del router y además arregla de raíz el rebote que tuvimos: la
// sesión se comprueba ANTES de montar nada, así que no existe el instante en
// que la pantalla se pinta sin sesión y se expulsa sola a quien acaba de
// entrar.
// ===========================================================================

export const Route = createFileRoute("/_app")({
  beforeLoad: async () => {
    let sesion: Awaited<ReturnType<typeof authClient.getSession>> | undefined;
    try {
      sesion = await authClient.getSession();
    } catch {
      // Servidor caído o error de red: se trata como si no hubiera sesión.
      throw redirect({ to: "/login" });
    }
    if (!sesion?.data) throw redirect({ to: "/login" });
    return { sesion: sesion.data };
  },
  component: Layout,
});

function Layout() {
  return (
    <TooltipProvider>
      <a
        href="#contenido"
        className="sr-only focus:not-sr-only focus:fixed focus:top-4 focus:left-4 focus:z-[100] focus:rounded-md focus:bg-primary focus:px-4 focus:py-2 focus:text-primary-foreground focus:shadow-lg"
      >
        Saltar al contenido
      </a>
      <SidebarProvider className="h-svh overflow-hidden">
        <AppSidebar />
        <SidebarInset className="overflow-hidden">
          <Topbar />
          <div
            id="contenido"
            tabIndex={-1}
            className="flex min-w-0 flex-1 flex-col gap-6 overflow-y-auto overflow-x-hidden px-4 py-4 focus:outline-none md:px-6 md:py-6 lg:px-8"
          >
            <Outlet />
          </div>
        </SidebarInset>
      </SidebarProvider>
    </TooltipProvider>
  );
}
